<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.999999940395355,3C13.719999940395356,3,13.469999940395356,3.11,13.289999940395354,3.29C13.289999940395354,3.29,5.999999940395355,10.59,5.999999940395355,10.59C5.999999940395355,10.59,2.709999940395355,7.29,2.709999940395355,7.29C2.5299999403953555,7.11,2.2799999403953555,7,1.9999999403953552,7C1.4499999403953552,7,0.9999999403953552,7.45,0.9999999403953552,8C0.9999999403953552,8.280000000000001,1.1099999403953553,8.530000000000001,1.2899999403953553,8.71C1.2899999403953553,8.71,5.289999940395355,12.71,5.289999940395355,12.71C5.469999940395355,12.89,5.719999940395355,13,5.999999940395355,13C6.2799999403953555,13,6.5299999403953555,12.89,6.709999940395355,12.71C6.709999940395355,12.71,14.709999940395356,4.71,14.709999940395356,4.71C14.889999940395356,4.53,14.999999940395355,4.28,14.999999940395355,4C14.999999940395355,3.45,14.549999940395356,3,13.999999940395355,3C13.999999940395355,3,13.999999940395355,3,13.999999940395355,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Tick',
} as DefineComponent
</script>
